import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueSweetalert2 from 'vue-sweetalert2';
import vuetify from './plugins/vuetify';
import VueKeyCloakJs from '@dsb-norge/vue-keycloak-js';
import VMdDateRangePicker from "v-md-date-range-picker";
import VueApexCharts from 'vue-apexcharts';

Vue.config.productionTip = false
Vue.use(VueSweetalert2);
Vue.use(VMdDateRangePicker);
Vue.use(VueApexCharts);

Vue.use(VueKeyCloakJs, {
  init: {
    onLoad: 'login-required'
  },
  config: {
    url: 'https://keycloak.prismatic-tech.com/auth',
    clientId: 'prismatic',
    realm: 'Prismatic'
  },
  logout: {
    redirectUri: 'https://mindef.prismatic-tech.com/'
  },
onReady: () => {
  tokenInterceptor();
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
    }).$mount('#app')
        
  }
});    
      
function tokenInterceptor() {
  axios.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${Vue.prototype.$keycloak.token}`;
    return config;
  }, error => {
    return Promise.reject(error);
  });
}